import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ChartCard = ({ icon, title, subtitle, height = 280, children, empty }) => (
  <div className="bg-white border border-slate-200 rounded-xl shadow-sm shadow-slate-900/[0.03] overflow-hidden">
    <header className="px-5 py-4 border-b border-slate-100">
      <div className="flex items-center gap-2">
        {icon && (
          <FontAwesomeIcon icon={icon} className="text-blue-600 w-3.5 h-3.5" />
        )}
        <h3 className="text-[14px] font-semibold text-slate-900">{title}</h3>
      </div>
      {subtitle && <p className="text-[11.5px] text-slate-500 mt-1">{subtitle}</p>}
    </header>
    <div style={{ height }} className="relative">
      {empty ? (
        <div className="absolute inset-0 grid place-items-center text-[12.5px] text-slate-400">
          {empty}
        </div>
      ) : children}
    </div>
  </div>
)

export default ChartCard
